import { Scan } from '@/tms/gbox-scans/_models/gbox-scans.model';
import { GboxResponseRow } from '@/tms/reports/_models/reports.model';

export function applyScanStatusUpdate(rows: GboxResponseRow[], scan: Scan): GboxResponseRow[] {
	return rows.map((row) => ({
		...row,
		answers:
			row.answers?.map((answer) =>
				answer.scan && answer.scan.id === scan.id
					? {
							...answer,
							scan: {
								...answer.scan,
								ocrStatus: scan.ocrStatus,
								costStatus: scan.costStatus,
								archiveStatus: scan.archiveStatus,
								updatedAt: scan.updated_at,
								driverLedgerEntryId: scan.driverLedgerEntryId,
							},
						}
					: answer,
			) ?? null,
	}));
}
